// This is a modal for Vendornominate

import { Button as AIMEButton } from "tot-loft-component-library";
import styled from "@emotion/styled";
import React from "react";

export default function ModalVendornominate({ onClose, buttonOnclick }) {
  return (
    <RootWrapperModalVendornominate>
      <Overlay>
        <Wrapper>
          <TermsAndCondtions>
            <Left>
              <Frame58>
                <Frame1391>
                  <TermsConditions>
                    Nominate a Vendor Terms & Conditions
                  </TermsConditions>
                  <ModalWrapper>
                    <Content01 className="pt-2">
                      By submitting a referral, you agree to the following:{" "}
                      <br />
                    </Content01>
                    <Subheading>Referral Accuracy</Subheading>
                    <Content01>
                      {" "}
                      You confirm that the information you’ve provided is
                      accurate, truthful, and submitted with the knowledge or
                      consent of the referred person. <br />
                    </Content01>
                    <Subheading>Eligibility</Subheading>
                    <Content01>
                      You may only submit referrals for individuals who are
                      genuinely interested in the business or service offered.
                      Spam, false leads, or self-referrals are strictly
                      prohibited. <br />
                    </Content01>
                    <Subheading>No Guarantee of Reward</Subheading>
                    <Content01>
                      Rewards are only issued if the referral results in a
                      successful business transaction, as defined by the vendor.
                      Submission alone does not guarantee payment. <br />
                    </Content01>
                    <Subheading>Review Process</Subheading>
                    <Content01>
                      All referrals are reviewed by the business. The business
                      reserves the right to accept or reject a referral at its
                      sole discretion. <br />
                    </Content01>
                    <Subheading>Data Usage </Subheading>
                    <Content01>
                      By submitting a referral, you grant us permission to share
                      the referred person's details with the vendor for business
                      purposes only. <br />
                    </Content01>
                    <Subheading>Dispute Rights</Subheading>
                    <Content01>
                      {" "}
                      In the event of a rejection, you may raise a dispute for
                      review, but the final decision lies with the platform
                      after investigation.
                      <br />
                    </Content01>
                    <Subheading>Reward Processing Time</Subheading>
                    <Content01>
                      If a referral is approved, reward payments may take 3–7
                      business days to process depending on your chosen payout
                      method.
                    </Content01>
                  </ModalWrapper>
                </Frame1391>
                <Frame59>
                  <AIMEButton
                    size="small"
                    onClick={onClose}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      flex: "none",
                      borderRadius: "999px",
                      background: "rgb(241, 245, 249)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      boxSizing: "border-box",
                      padding: "16px 32px",
                      "&:hover": {
                        background: "rgb(241, 245, 249)",
                        opacity: "0.9",
                      },
                    }}
                  >
                    <span
                      style={{
                        color: "rgb(33, 37, 67)",
                        textOverflow: "ellipsis",
                        fontSize: "16px",
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: "600",
                        lineHeight: "110%",
                        textAlign: "left",
                      }}
                    >
                      Clear
                    </span>
                  </AIMEButton>

                  <AIMEButton
                    size="small"
                    onClick={buttonOnclick}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      flex: "none",
                      gap: "8px",
                      borderRadius: "999px",
                      width: "320px",
                      height: "50px",
                      background: "rgb(97, 98, 197)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      boxSizing: "border-box",
                      padding: "16px 32px",
                      "&:hover": {
                        background: "rgb(97, 98, 197)",
                        opacity: "0.9",
                      },
                      "@media (max-width:600px)": {
                        width: "50%",
                      },
                    }}
                  >
                    <span
                      style={{
                        color: "white",
                        textOverflow: "ellipsis",
                        fontSize: "16px",
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: "600",
                        lineHeight: "110%",
                        textAlign: "left",
                      }}
                    >
                      I Agree
                    </span>
                  </AIMEButton>
                </Frame59>
              </Frame58>
            </Left>
          </TermsAndCondtions>
        </Wrapper>
      </Overlay>
    </RootWrapperModalVendornominate>
  );
}

const RootWrapperModalVendornominate = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;

  box-sizing: border-box;
`;

const Overlay = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 8px;
  background: linear-gradient(-90deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  border-radius: 32px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 40px 24px 24px;
`;



const TermsAndCondtions = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 912px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  width: 912px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame58 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1391 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const TermsConditions = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 30px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const ModalWrapper = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
  gap: 20px;
`;
const Subheading = styled.h3`
  font-family: Montserrat;
  font-weight: 700;
  font-size: 14px;
  line-height: 160%;
  letter-spacing: 0%;
  color: #212543;
  margin-top: 12px;
`;

const Content01 = styled.p`
  font-family: Montserrat;
  font-weight: 500;
  font-size: 14px;
  line-height: 160%;
  letter-spacing: 0%;
  color: rgba(33, 37, 67, 1);
`;
const Frame59 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;
